import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, withRouter, Redirect} from 'react-router-dom';
import {CompactSearch} from '../search';
import {Avatar} from '../widgets';
import SearchUserTypeSelector from '../search/SearchUserTypeSelector';
import actions from '../search/search.actions';
import {STREAM_WHITELISTED_USERS} from '../betaFeatureWhiteList';

import './MobileNav.css';

const searchRe = /^\/search\/*./;

class MobileNav extends Component {
	constructor(props) {
		super(props);

		this.state = {
			compact: false,
			scrolling: false,
			scrollStart: null,
			prevPath: '',
			redirect: false
		};

		this.scrollHandler = () => {
			if (this.timeout) {
				clearTimeout(this.timeout);
			}

			this.timeout = setTimeout(() => {
				// scrolling has stopped
				this.timeout = null;
				this.setState(state => ({
					scrolling: false,
					scrollStart: null,
					compact: window.pageYOffset < 100 ? false : state.compact
				}));
			}, 500);

			if (!this.state.scrolling) {
				// scrolling has started
				this.setState({scrolling: true, scrollStart: window.pageYOffset});
			}

			const dist = this.state.scrollStart - window.pageYOffset;
			if (dist > 50) {
				this.setState({compact: false, scrollStart: window.pageYOffset});
			} else if (dist < -50) {
				this.setState({compact: true, scrollStart: window.pageYOffset});
			}
		};

		// search functions
		this.searchForProvider = () => {
			if (this.props.searchFor !== 'provider' && !this.props.query) this.props.resetState();
			this.props.search('provider');
			this.setState({redirect: true});
		};
		this.searchForCommunity = () => {
			if (this.props.searchFor !== 'community' && !this.props.query) this.props.resetState();
			this.props.search('community');
			this.setState({redirect: true});
		};
		this.searchForUser = () => {
			if (this.props.searchFor !== 'user' && !this.props.query) this.props.resetState();
			this.props.search('user');
			this.setState({redirect: true});
		};

		this.goBack = () => {
			// always go back to the homepage if on search category page
			if (this.props.location.pathname === '/search-category/') {
				this.props.history.push('/');
			} else if (this.props.location.pathname === '/schools/') {
				this.props.history.goBack();
				window.location.reload(); // required to remove chatbot
			} else {
				this.props.history.goBack();
			}
		};
	}

	componentDidUpdate() {
		if (this.state.redirect) {
			this.setState({redirect: false}); // Redirect should only execute once
		}
	}

	componentWillMount() {
		window.addEventListener('scroll', this.scrollHandler);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.scrollHandler);
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.location.pathname !== this.props.location.pathname &&
			(this.props.location.pathname === '/' || searchRe.test(this.props.location.pathname))
		) {
			this.setState({prevPath: this.props.location.pathname});
		}
	}

	render() {
		const {
			current,
			signup,
			login,
			toggleUserMenu,
			notificationItems,
			avatarImage,
			chatNotifCount,
			isHome,
			query,
			searchFor
		} = this.props;

		return (
			<nav className={`MobileNav ${this.state.compact ? 'compact' : ''}`}>
				{this.state.redirect && <Redirect push to={`/search/${query || ''}`} />}
				<div>
					<div className="btnDiv">
						{!isHome && (
							<a onClick={this.goBack} className="backArrow">
								<span className="icon icon-keyboard_arrow_left" />
							</a>
						)}
						<Link to="/">
							<h1>
								<img alt="B2Me" src="/img/b2me-header.svg" />
							</h1>
						</Link>
						<span className="PageHeader-spacer" />

						{!current && (
							<button className="PageHeader-signup" onClick={signup}>
								<em>Free</em> sign up
							</button>
						)}
						{!current && (
							<button className="PageHeader-login" onClick={login}>
								Log in
							</button>
						)}
						{current &&
							current.provider &&
							(current.user.admin || STREAM_WHITELISTED_USERS.includes(current.user.uuid)) && (
								<Link to="/stream/" className="PageHeader-stream">
									<span className="icon icon-view_day" />
								</Link>
							)}
						{current && current.provider && current.provider.profile && (
							<Link to={`/chats/`} className="PageHeader-chats">
								{chatNotifCount ? (
									<span className="PageHeader-badge">{chatNotifCount}</span>
								) : (
									undefined
								)}
								<span className="icon icon-message" />
							</Link>
						)}
						{current && current.provider && current.provider.profile && (
							<Link
								to={`/collections/${current.provider.profile.uniqueName}`}
								className="PageHeader-profile">
								<span className="icon icon-favorite" />
							</Link>
						)}
						<button onClick={toggleUserMenu} className="Menu">
							<span className="icon icon-menu" />
							{notificationItems && notificationItems.length ? (
								<span className="PageHeader-badge">{notificationItems.length}</span>
							) : (
								undefined
							)}
						</button>
					</div>
					<CompactSearch
						refGetter={el => (this.search = el)}
						className={'CompactSearch'}
						onBlur={null}
						radii={false}
						enableUserTypeSelector={false}
						query={query}
					/>
				</div>

				<SearchUserTypeSelector
					compact={false}
					setSearchProvider={this.searchForProvider}
					setSearchCommunity={this.searchForCommunity}
					setSearchUser={this.searchForUser}
					radii={false}
					searchFor={searchFor}
				/>
			</nav>
		);
	}
}

export default withRouter(
	connect(
		state => ({
			lastAction: state.lastAction,
			query: state.search.query,
			searchFor: state.search.searchFor
		}),
		dispatch => ({
			search: searchFor => {
				dispatch(actions.searchFor(searchFor));
				dispatch(actions.performSearch());
			},
			resetState: () => dispatch(actions.resetState())
		})
	)(MobileNav)
);



// WEBPACK FOOTER //
// ./src/chrome/MobileNav.js